var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.2341 8.74963L11.5637 6.578H9.50317V5.16875C9.50317 4.57475 9.79091 3.99538 10.7138 3.99538H11.6505V2.14662C11.6505 2.14662 10.8006 2 9.98781 2C8.29101 2 7.18193 3.04025 7.18193 4.92313V6.57837H5.29565V8.75H7.18193V14H9.50317V8.75L11.2341 8.74963Z","fill":"white"}));
}

Facebook.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
